import { render, staticRenderFns } from "./SyslogTable.vue?vue&type=template&id=2fb45bd2&"
import script from "./SyslogTable.vue?vue&type=script&lang=js&"
export * from "./SyslogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports